import { AoReport } from './ao-report';

export class AoReportMaterial extends AoReport {
  materialId: string;
  materialLabel: string;
  tagMac: string;
  tagLabel: string;

  override getLabel(): string {
    return `${this.materialLabel} (${this.materialId})`;
  }

  public override getDeviceId(): string {
    return this.materialId;
  }
}
